import { render } from "react-dom";

export default function jsxElementToHtml(jsxElement: JSX.Element) {
  const tempDiv = document.createElement("div");
  render(jsxElement, tempDiv);
  return tempDiv.innerHTML;
}
